/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_TitleInputs */

const en_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

const es_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeja de entrada`)
};

const fr_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte de réception`)
};

const de_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posteingang`)
};

const ja_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信トレイ`)
};

const zh_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收件箱`)
};

const ar_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صندوق الوارد`)
};

const id_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotak Masuk`)
};

const it_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi`)
};

const ru_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входящие`)
};

const pt_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixa de Entrada`)
};

const ko_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수신함`)
};

/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Inbox_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_title = /** @type {((inputs?: Inbox_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_title(inputs)
	if (locale === "es") return es_inbox_title(inputs)
	if (locale === "fr") return fr_inbox_title(inputs)
	if (locale === "de") return de_inbox_title(inputs)
	if (locale === "ja") return ja_inbox_title(inputs)
	if (locale === "zh") return zh_inbox_title(inputs)
	if (locale === "ar") return ar_inbox_title(inputs)
	if (locale === "id") return id_inbox_title(inputs)
	if (locale === "it") return it_inbox_title(inputs)
	if (locale === "ru") return ru_inbox_title(inputs)
	if (locale === "pt") return pt_inbox_title(inputs)
	return ko_inbox_title(inputs)
});